var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.deviceType === 'pc' ? '' : 'app2',attrs:{"id":"app"}},[(_vm.$route.path.indexOf('/login') === -1)?_c('layout'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }